import type { UserRole } from '@constants/roles';
import { ROUTES } from '@constants/routes';
import { useAuthStore } from '@store/authStore';
import { Navigate, Outlet } from 'react-router-dom';


interface RoleRouteProps {
  requiredRole: UserRole;
}

export const RoleRoute = ({ requiredRole }: RoleRouteProps) => {
  const { user } = useAuthStore();

  if (user?.role !== requiredRole) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <Outlet />;
};
